React = require('react')

module.exports = React.createClass
    render: ->
        return (
            React.createElement("div", {"className": "generic-content"},
                React.createElement("h2", null, (@props.title)),
                React.createElement("p", {"className": "content"}, (@props.children))
            )
        )


/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/modules/generic-content.cjsx
 **/